export default {"src":"/_next/static/media/logo-white.6d69c2e2.svg","height":40,"width":204,"blurWidth":0,"blurHeight":0};